module.exports = __webpack_public_path__ + "static/img/logo.c782fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/logo.png
// module id = ZAr/
// module chunks = 0